import Vue from 'vue'
import Vuex from 'vuex'
import routes from './modules/routes'
import menus from './modules/menus'
import home from './modules/home'
import editors from './modules/editors'
import featured from './modules/featured'
import news from './modules/news'
import contacts from './modules/contacts'
import socials from './modules/socials'
import player from './modules/player'
import ui from './modules/ui'
//import createLogger from '../../../src/plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        routes,
        menus,
        home,
        editors,
        featured,
        news,
        contacts,
        socials,
        player,
        ui,
    },
    strict: debug,
    //plugins: debug ? [createLogger()] : []
})